import { configureStore, combineReducers } from '@reduxjs/toolkit';
import authReducer from './auth-slice';
import UIReducer from './ui-slice';
import eventsReducer from './events-slice';

export const rootReducer = combineReducers({
  auth: authReducer,
  ui: UIReducer,
  events: eventsReducer
});

const store = configureStore({
  reducer: rootReducer
});

export type RootState = ReturnType<typeof rootReducer>
export type AppDispatch = typeof store.dispatch;
export default store;